import React, { useEffect, useState } from "react"
import "./ViewProgram.scss"
import { Button, Card, CardBody, Col, Row } from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { InputText } from "primereact/inputtext"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import programApi from "Api/programApi"

const ViewProgram = () => {
  document.title = "View Program"

  const accessToken = localStorage.getItem("accessToken")
  const navigate = useNavigate("")
  const location = useLocation()
  const { programId } = useParams()
  const [programData, setProgramData] = useState({})
  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Program", link: "#" },
    { label: "Program Details", link: "#" },
  ]

  const getProgram = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    programApi
      .getProgramById(programId, config)
      .then(res => {
        setProgramData(res.data.program)
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    if (programId) {
      getProgram()
    }
  }, [programId])

  return (
    <div className="view-program">
      <Row>
        <Col xs="12">
          <div className="program-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="program Details"
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="program-view-form ">
                <div className="program-view-inp">
                  <label htmlFor="university" className="label">
                    university
                  </label>
                  <span
                    className="institution-view-inp-span"
                    onClick={() => {
                      navigate(
                        `/view-university/${programData?.university?.universityCode}`,
                      )
                    }}
                  >
                    {programData?.university?.universityName}
                  </span>
                </div>
                <div className="program-view-inp">
                  <label htmlFor="Institution" className="label">
                    Institution
                  </label>
                  <span
                    className="institution-view-inp-span"
                    onClick={() => {
                      navigate(
                        `/view-institution/${programData?.institution?.institutionCode}`,
                      )
                    }}
                  >
                    {programData?.institution?.institutionName}
                  </span>
                </div>

                <div className="program-view-inp">
                  <label htmlFor="programName" className="label">
                    Program Name
                  </label>
                  <InputText
                    id="programName"
                    value={programData.programName}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="program-view-inp">
                  <label htmlFor="duration" className="label">
                    Duration
                  </label>
                  <InputText
                    id="duration"
                    value={programData.duration}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="program-view-inp">
                  <label htmlFor="level" className="label">
                    Level
                  </label>

                  <InputText
                    id="level"
                    value={programData.level}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="program-view-inp">
                  <label htmlFor="eligibilityCriteria" className="label">
                    EligibilityCriteria
                  </label>
                  <InputText
                    id="eligibilityCriteria"
                    value={programData.eligibilityCriteria}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="program-view-inp">
                  <label htmlFor="totalSeats" className="label">
                    TotalSeats
                  </label>
                  <InputText
                    id="totalSeats"
                    value={programData.totalSeats}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="program-view-inp">
                  <label htmlFor="tuitionFee" className="label">
                    TuitionFee
                  </label>

                  <InputText
                    id="tuitionFee"
                    value={programData.tuitionFee}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="program-view-inp">
                  <label htmlFor="admissionFee" className="label">
                    AdmissionFee
                  </label>
                  <InputText
                    id="admissionFee"
                    value={programData.admissionFee}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="program-view-inp">
                  <label htmlFor="Scholarship" className="label">
                    Scholarship
                  </label>
                  <InputText
                    id="Scholarship"
                    value={programData.scholarships}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="program-view-inp">
                  <label htmlFor="intakeYear" className="label">
                    IntakeYear
                  </label>
                  <InputText
                    id="intakeYear"
                    value={programData.intakeYear}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="program-view-inp">
                  <label htmlFor="modeOfStudy" className="label">
                    modeOfStudy
                  </label>

                  <InputText
                    id="modeOfStudy"
                    value={programData.modeOfStudy}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="program-view-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <InputText
                    id="description"
                    value={programData.description}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="program-view-inp">
                  <label htmlFor="verifiedStatus" className="label">
                    Verified Status
                  </label>
                  <InputText
                    id="verifiedStatus"
                    value={
                      programData.verifiedStatus === "approve"
                        ? "Yes"
                        : "No"
                          ? "Yes"
                          : "No"
                    }
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="program-view-inp">
                  <label htmlFor="verifiedReason" className="label">
                    Verified Reason
                  </label>
                  <InputText
                    id="verifiedReason"
                    value={
                      programData.verifiedReason
                        ? programData.verifiedReason
                        : "-"
                    }
                    className="inp-field-box"
                    disabled
                  />
                </div>
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-start gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Back
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default ViewProgram
